type ProgressBarProps = {
  percentage: number;
  backgroundColor: string;
};

const ProgressBar = ({ percentage, backgroundColor }: ProgressBarProps) => {
  // Ensure the percentage is within the valid range [0, 100]
  const clampedPercentage = Math.max(0, Math.min(100, percentage));

  return (
    <div className="flex w-20 h-[5px] mb-4 overflow-hidden text-xs bg-violet-100 rounded">
      <div
        style={{
          width: `${clampedPercentage}%`,
          backgroundColor: backgroundColor,
        }}
        className={`flex flex-col whitespace-nowrap text-white justify-center bg-${backgroundColor} shadow-none transition-all duration-300`}
      ></div>
    </div>
  );
};

export default ProgressBar;
